module.exports = __webpack_public_path__ + "img/40.6ba07e32.png";